(function () {
    var cfg = window.MFF && window.MFF.pwaSession;
    if (!cfg) return;
  
    var STORAGE_KEY = cfg.storageKey || 'pwa_app_user_logged_in';
    var COOKIE_KEY = 'mff_pwa_app_user';
    var PROBE_KEY = '__mff_pwa_storage_probe__';
    var TTL_MS = cfg.ttlMs || 3600000;
    var ONE_HOUR = TTL_MS;
    var COOKIE_MAX_AGE_SEC = Math.floor(ONE_HOUR / 1000);
  
    function isPwaView() {
      return /(?:\?|&)view=pwa(?:&|$)/.test(window.location.search || '');
    }
  
    function isInPwaAppContext() {
      if (isPwaView()) return true;
  
      var ua = navigator.userAgent || '';
      if (/\bwv\b|WebView|Android.*Version\/\d/i.test(ua)) return true;
      if (/pwa|pwamobile|shopify.*mobile.*app/i.test(ua)) return true;
  
      try {
        if (window.matchMedia('(display-mode: standalone)').matches) return true;
      } catch (e) {}
  
      if (window.navigator.standalone === true) return true;
  
      var ref = document.referrer || '';
      if (ref.indexOf('android-app://') === 0) return true;
  
      return false;
    }
  
    function cookieSecureSuffix() {
      return window.location.protocol === 'https:' ? '; Secure' : '';
    }
  
    /** Cookie store — same role as localStorage for native WebView */
    var cookieStore = {
      available: false,
  
      probe: function () {
        try {
          var secure = cookieSecureSuffix();
          document.cookie = PROBE_KEY + '=1; path=/; max-age=60; SameSite=Lax' + secure;
          var ok = document.cookie.indexOf(PROBE_KEY + '=1') !== -1;
          document.cookie = PROBE_KEY + '=; path=/; max-age=0; SameSite=Lax' + secure;
          this.available = ok;
          return ok;
        } catch (e) {
          this.available = false;
          return false;
        }
      },
  
      get: function () {
        if (!this.available) return null;
        try {
          var match = document.cookie.match(new RegExp('(?:^|;\\s*)' + COOKIE_KEY + '=([^;]*)'));
          if (!match) return null;
          return decodeURIComponent(match[1]);
        } catch (e) {
          this.available = false;
          return null;
        }
      },
  
      set: function (payload) {
        if (!this.available) return false;
        try {
          document.cookie =
            COOKIE_KEY +
            '=' +
            encodeURIComponent(payload) +
            '; path=/; max-age=' +
            COOKIE_MAX_AGE_SEC +
            '; SameSite=Lax' +
            cookieSecureSuffix();
          return true;
        } catch (e) {
          this.available = false;
          return false;
        }
      },
  
      remove: function () {
        if (!this.available) return;
        try {
          document.cookie = COOKIE_KEY + '=; path=/; max-age=0; SameSite=Lax' + cookieSecureSuffix();
        } catch (e) {
          this.available = false;
        }
      }
    };
  
    cookieStore.probe();
  
    var optionalLocal = false;
    var optionalSession = false;
  
    try {
      localStorage.setItem(PROBE_KEY, '1');
      optionalLocal = localStorage.getItem(PROBE_KEY) === '1';
      localStorage.removeItem(PROBE_KEY);
    } catch (e) {
      optionalLocal = false;
    }
  
    try {
      sessionStorage.setItem(PROBE_KEY, '1');
      optionalSession = sessionStorage.getItem(PROBE_KEY) === '1';
      sessionStorage.removeItem(PROBE_KEY);
    } catch (e) {
      optionalSession = false;
    }
  
    cfg.storageBackends = {
      cookie: cookieStore.available,
      session: optionalSession,
      local: optionalLocal
    };
    cfg.inPwaAppContext = isInPwaAppContext();
    cfg.primaryStorage = 'cookie';
  
    function canPersistFlag() {
      if (cookieStore.available) return true;
      if (cfg.inPwaAppContext) return false;
      return optionalLocal || optionalSession;
    }
  
    function isAccountPath() {
      var path = window.location.pathname || '/';
      return path.indexOf('/account') === 0;
    }
  
    function shouldSkipGuestRedirect() {
      var search = window.location.search || '';
  
      if (/(?:\?|&)logged_out=1(?:&|$)/.test(search)) return true;
  
      var ref = document.referrer || '';
      if (ref.indexOf('/account/logout') !== -1) {
        clearStoredFlag();
        return true;
      }
  
      if (isAccountPath()) return true;
  
      return false;
    }
  
    function parseFlagPayload(raw) {
      if (!raw) return null;
      try {
        var data = JSON.parse(raw);
        if (!data || data.value !== true || !data.expiresAt) return null;
        if (Date.now() > data.expiresAt) return null;
        return data;
      } catch (e) {
        return null;
      }
    }
  
    function readOptionalStorages() {
      if (optionalLocal) {
        try {
          var fromLocal = parseFlagPayload(localStorage.getItem(STORAGE_KEY));
          if (fromLocal) return fromLocal;
        } catch (e) {
          optionalLocal = false;
        }
      }
      if (optionalSession) {
        try {
          var fromSession = parseFlagPayload(sessionStorage.getItem(STORAGE_KEY));
          if (fromSession) return fromSession;
        } catch (e) {
          optionalSession = false;
        }
      }
      return null;
    }
  
    function readStoredData() {
      var fromCookie = parseFlagPayload(cookieStore.get());
      if (fromCookie) return fromCookie;
  
      if (cfg.inPwaAppContext) return null;
  
      return readOptionalStorages();
    }
  
    function mirrorToOptionalStorages(payload) {
      if (cfg.inPwaAppContext) return;
  
      if (optionalLocal) {
        try {
          localStorage.setItem(STORAGE_KEY, payload);
        } catch (e) {
          optionalLocal = false;
        }
      }
      if (optionalSession) {
        try {
          sessionStorage.setItem(STORAGE_KEY, payload);
        } catch (e) {
          optionalSession = false;
        }
      }
    }
  
    function readStoredFlag() {
      if (!canPersistFlag()) return false;
  
      var data = readStoredData();
      if (!data) {
        clearStoredFlag();
        return false;
      }
  
      var payload = JSON.stringify(data);
      cookieStore.set(payload);
      mirrorToOptionalStorages(payload);
      return true;
    }
  
    function setStoredFlag() {
      if (!canPersistFlag()) return;
  
      var payload = JSON.stringify({
        value: true,
        expiresAt: Date.now() + ONE_HOUR
      });
  
      cookieStore.set(payload);
      mirrorToOptionalStorages(payload);
    }
  
    function clearStoredFlag() {
      cookieStore.remove();
  
      if (optionalLocal) {
        try {
          localStorage.removeItem(STORAGE_KEY);
        } catch (e) {
          optionalLocal = false;
        }
      }
      if (optionalSession) {
        try {
          sessionStorage.removeItem(STORAGE_KEY);
        } catch (e) {
          optionalSession = false;
        }
      }
    }
  
    window.MFF.clearPwaAppLoggedInFlag = clearStoredFlag;
  
    function buildLoginUrl() {
      try {
        var login = new URL(cfg.loginUrl, window.location.origin);
        login.searchParams.set('view', 'pwa');
  
        var returnPath = window.location.pathname + window.location.search;
        if (!returnPath || returnPath === '') returnPath = cfg.rootUrl || '/';
  
        login.searchParams.set('redirect_url', returnPath);
        return login.toString();
      } catch (e) {
        return cfg.loginUrl + '?view=pwa';
      }
    }
  
    function buildRegisterUrl() {
      try {
        var register = new URL(cfg.registerUrl, window.location.origin);
        register.searchParams.set('view', 'pwa');
        register.searchParams.set('redirect_url', cfg.rootUrl || '/');
        return register.toString();
      } catch (e) {
        return cfg.registerUrl + '?view=pwa';
      }
    }
  
    function isReturningPwaAppUser() {
      return readStoredFlag();
    }
  
    function redirectGuestToLogin() {
      window.location.replace(buildLoginUrl());
    }
  
    function redirectGuestToRegister() {
      window.location.replace(buildRegisterUrl());
    }
  
    if (cfg.isLoggedIn) {
      if (isInPwaAppContext() || isReturningPwaAppUser()) {
        setStoredFlag();
      }
      return;
    }
  
    if (!cfg.isLoggedIn) {
      if (shouldSkipGuestRedirect()) return;
  
      if (isReturningPwaAppUser()) {
        redirectGuestToLogin();
        return;
      }
  
      if (isInPwaAppContext()) {
        redirectGuestToRegister();
      }
    }
  })();
  